import { ValueOf } from 'type-fest'

import { createReducer } from 'lib/redux/reducerUtils'
import { AITripFormData } from 'tripPlanner/types/common'

export default interface AITripSearchState {
  budget: AITripFormData['budget'] | undefined
  message: string
  isRecommendationsOn: boolean
  isFlexibleDates: boolean
  origin?: App.SearchItem
  destination?: App.SearchItem
}

export enum AITripSearchStateActions {
  SET_BUDGET = 'SET_BUDGET',
  SET_MESSAGE = 'SET_MESSAGE',
  TOGGLE_RECOMMENDATIONS = 'TOGGLE_RECOMMENDATIONS',
  TOGGLE_FLEXIBLE_DATES = 'TOGGLE_FLEXIBLE_DATES',
  SET_ORIGIN = 'SET_ORIGIN',
  SET_DESTINATION = 'SET_DESTINATION',
}

export type AITripSearchAction = ValueOf<
  Utils.FullActionMap<{
    [AITripSearchStateActions.SET_BUDGET]: {
      budget: AITripSearchState['budget']
    }
    [AITripSearchStateActions.SET_MESSAGE]: {
      message: AITripSearchState['message']
    }
    [AITripSearchStateActions.TOGGLE_RECOMMENDATIONS]: {
      isRecommendationsOn: AITripSearchState['isRecommendationsOn']
    }
    [AITripSearchStateActions.TOGGLE_FLEXIBLE_DATES]: {
      isFlexibleDates: AITripSearchState['isFlexibleDates']
    }
    [AITripSearchStateActions.SET_ORIGIN]: {
      origin: AITripSearchState['origin']
    }
    [AITripSearchStateActions.SET_DESTINATION]: {
      destination: AITripSearchState['destination']
    }
  }>
>

export const AI_TRIP_SEARCH_INITIAL_STATE: AITripSearchState = {
  budget: undefined,
  message: '',
  isRecommendationsOn: false,
  isFlexibleDates: false,
  origin: undefined,
  destination: undefined,
}

export const aiTripSearchStateReducer = createReducer(
  AI_TRIP_SEARCH_INITIAL_STATE,
  {
    [AITripSearchStateActions.SET_BUDGET]: (state, action) => ({
      budget: action.budget,
    }),
    [AITripSearchStateActions.SET_MESSAGE]: (state, action) => ({
      message: action.message,
    }),
    [AITripSearchStateActions.TOGGLE_RECOMMENDATIONS]: (state, action) => ({
      isRecommendationsOn: action.isRecommendationsOn,
    }),
    [AITripSearchStateActions.TOGGLE_FLEXIBLE_DATES]: (state, action) => ({
      isFlexibleDates: action.isFlexibleDates,
    }),
    [AITripSearchStateActions.SET_ORIGIN]: (state, action) => ({
      origin: action.origin,
    }),
    [AITripSearchStateActions.SET_DESTINATION]: (state, action) => ({
      destination: action.destination,
    }),
  },
)
